// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.analyze-dialog-content {
  padding: 16px 20px 8px;
  min-width: 0;
  max-width: 100%;
  max-height: 78vh;
  overflow-y: auto;
}
@media (max-width: 1054px) {
  .analyze-dialog-content {
    min-width: 100% !important;
    width: 100%;
    max-width: 100%;
  }
}
.analyze-dialog-content h1 {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 12px;
  text-align: center;
  color: rgba(0, 0, 0, 0.8705882353);
}
.analyze-dialog-content .row {
  display: flex;
  flex-direction: column;
  margin-bottom: 18px;
}
.analyze-dialog-content .row.double {
  flex-direction: row;
  gap: 20px;
}
.analyze-dialog-content .row.double mat-form-field {
  flex: 1;
}
.analyze-dialog-content .custom-periods {
  margin-top: 8px;
}
.analyze-dialog-content .custom-periods .row {
  align-items: center;
  gap: 12px;
  margin-bottom: 18px;
}
.analyze-dialog-content .custom-periods .period-actions {
  display: flex;
  align-items: center;
  gap: 32px;
}
.analyze-dialog-content .custom-periods .period-actions button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 40px;
  width: 40px;
}
.analyze-dialog-content mat-form-field {
  width: 100%;
}

.buttons {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  margin-bottom: 20px;
}
.buttons .btn-back {
  width: 8rem !important;
}
.buttons a {
  text-decoration: none;
  color: #ae0f0a;
  margin-left: 32px;
}

::ng-deep .periodo-field {
  position: relative;
}

::ng-deep .periodo-field .input-suffix {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: rgba(0, 0, 0, 0.6);
  pointer-events: none;
}

.date-range-field,
.date-input {
  width: 100%;
}

::ng-deep.mat-mdc-form-field-subscript-wrapper {
  height: 0 !important;
}

.rw {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin: 16px 16px;
}

.w-100 {
  width: 100%;
}

@media (max-width: 1054px) {
  .double {
    flex-direction: column !important;
  }
}
::ng-deep .contratual-tipo-relatorio-panel {
  min-width: 420px !important;
}

::ng-deep .contratual-tipo-relatorio-panel .mat-mdc-option {
  min-height: 48px;
  padding-top: 4px;
  padding-bottom: 4px;
  white-space: normal;
  line-height: 1.4;
}

::ng-deep .contratual-tipo-relatorio-panel .mdc-list-item__primary-text {
  white-space: normal;
}`, "",{"version":3,"sources":["webpack://./src/app/modules/shared/modals/form-relatorio/form-relatorio.component.scss"],"names":[],"mappings":"AAAA;EACE,sBAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AACF;AAAE;EANF;IAOI,0BAAA;IACA,WAAA;IACA,eAAA;EAGF;AACF;AACE;EACE,eAAA;EACA,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kCAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;AAAJ;AAGE;EACE,mBAAA;EACA,SAAA;AADJ;AAGI;EACE,OAAA;AADN;AAKE;EACE,eAAA;AAHJ;AAKI;EACE,mBAAA;EACA,SAAA;EACA,mBAAA;AAHN;AAMI;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAJN;AAMM;EACE,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;EACA,WAAA;AAJR;AASE;EACE,WAAA;AAPJ;;AAWA;EACE,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACC,mBAAA;AARH;AASE;EACE,sBAAA;AAPJ;AASE;EACE,qBAAA;EACA,cAAA;EACA,iBAAA;AAPJ;;AAUA;EACE,kBAAA;AAPF;;AAUA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,eAAA;EACA,yBAAA;EACA,oBAAA;AAPF;;AASA;;EAEE,WAAA;AANF;;AAQA;EACE,oBAAA;AALF;;AAOA;EACE,aAAA;EACA,eAAA;EACA,8BAAA;EACA,iBAAA;AAJF;;AAQA;EACE,WAAA;AALF;;AAOA;EAEE;IACE,iCAAA;EALF;AACF;AASA;EACE,2BAAA;AAPF;;AAUA;EACE,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AAPF;;AAUA;EACE,mBAAA;AAPF","sourcesContent":[".analyze-dialog-content {\n  padding: 16px 20px 8px;\n  min-width: 0;\n  max-width: 100%;\n  max-height: 78vh;\n  overflow-y: auto;\n  @media(max-width:1054px){\n    min-width: 100% !important;\n    width: 100%;\n    max-width: 100%;\n\n\n  }\n\n  h1 {\n    font-size: 24px;\n    font-weight: bold;\n    margin-bottom: 12px;\n    text-align: center;\n    color: #000000DE;\n  }\n\n  .row {\n    display: flex;\n    flex-direction: column;\n    margin-bottom: 18px;\n  }\n\n  .row.double {\n    flex-direction: row;\n    gap: 20px;\n\n    mat-form-field {\n      flex: 1;\n    }\n  }\n\n  .custom-periods {\n    margin-top: 8px;\n\n    .row {\n      align-items: center;\n      gap: 12px;\n      margin-bottom: 18px;\n    }\n\n    .period-actions {\n      display: flex;\n      align-items: center;\n      gap: 32px;\n\n      button {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        height: 40px;\n        width: 40px;\n      }\n    }\n  }\n\n  mat-form-field {\n    width: 100%;\n  }\n}\n\n.buttons {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px;\n   margin-bottom: 20px;\n  .btn-back {\n    width: 8rem !important;\n  }\n  a {\n    text-decoration: none;\n    color: #ae0f0a;\n    margin-left: 32px;\n  }\n}\n::ng-deep .periodo-field {\n  position: relative;\n}\n\n::ng-deep .periodo-field .input-suffix {\n  position: absolute;\n  right: 16px;\n  top: 50%;\n  transform: translateY(-50%);\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.6);\n  pointer-events: none;\n}\n.date-range-field,\n.date-input {\n  width: 100%;\n}\n::ng-deep.mat-mdc-form-field-subscript-wrapper {\n  height: 0 !important;\n}\n.rw{\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  margin: 16px 16px;\n}\n\n\n.w-100{\n  width: 100%;\n}\n@media(max-width:1054px){\n\n  .double{\n    flex-direction: column !important;\n  }\n\n}\n\n::ng-deep .contratual-tipo-relatorio-panel {\n  min-width: 420px !important;\n}\n\n::ng-deep .contratual-tipo-relatorio-panel .mat-mdc-option {\n  min-height: 48px;\n  padding-top: 4px;\n  padding-bottom: 4px;\n  white-space: normal;\n  line-height: 1.4;\n}\n\n::ng-deep .contratual-tipo-relatorio-panel .mdc-list-item__primary-text {\n  white-space: normal;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
